import { render, staticRenderFns } from "./GridRecipeContent.vue?vue&type=template&id=1bd7e72e&scoped=true&"
import script from "./GridRecipeContent.vue?vue&type=script&lang=js&"
export * from "./GridRecipeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7e72e",
  null
  
)

export default component.exports